module.exports = __webpack_public_path__ + "img/logo.29b3f33e.png";